import { BATTLESHIP } from 'HubStyleTokens/colors';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import styled from 'styled-components';
import { PermissionsProvider } from '../context/PermissionsContext';
import SubscriptionHighlight from './SubscriptionHighlight';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHighlight = styled.div.withConfig({
  displayName: "SubscriptionHighlightWrapper__StyledHighlight",
  componentId: "z721k2-0"
})(["border-bottom:1px solid ", ";padding:24px 24px 14px 24px;"], BATTLESHIP);
function SubscriptionHighlightWrapper({
  objectId,
  permissions,
  auth,
  closeSidebar
}) {
  return /*#__PURE__*/_jsx(StyledHighlight, {
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      boundaryName: "SubscriptionHighlightCard",
      showRefreshAlert: true,
      ErrorComponent: UIErrorMessage,
      children: /*#__PURE__*/_jsx(PermissionsProvider, {
        values: Object.assign({}, permissions, auth, {
          closeSidebar
        }),
        children: /*#__PURE__*/_jsx(SubscriptionHighlight, {
          objectId: objectId
        })
      })
    })
  });
}
export default SubscriptionHighlightWrapper;